export default {
  route: {
    card_group_invoicing: '开票管理',
    card_gift: '赠品管理',
    card_group_recharge_gift: '设备充值赠送配置',
    card_group_recharge_gift_log: '设备充值赠送记录',
    charge: '资费',
    chargeItem: '资费内容',
    documentation: '文档',
    notice: '通知公告',
    guide: '引导页',
    pagePermission: '页面权限',
    directivePermission: '指令权限',
    icons: '图标',
    components: '组件',
    componentIndex: '介绍',
    tinymce: '富文本编辑器',
    markdown: 'Markdown',
    jsonEditor: 'JSON编辑器',
    dndList: '列表拖拽',
    splitPane: 'Splitpane',
    avatarUpload: '头像上传',
    dropzone: 'Dropzone',
    sticky: 'Sticky',
    countTo: 'CountTo',
    componentMixin: '小组件',
    backToTop: '返回顶部',
    dragDialog: '拖拽 Dialog',
    dragSelect: '拖拽 Select',
    dragKanban: '可拖拽看板',
    charts: '图表',
    keyboardChart: '键盘图表',
    lineChart: '折线图',
    mixChart: '混合图表',
    example: '综合实例',
    nested: '路由嵌套',
    menu1: '菜单1',
    'menu1-1': '菜单1-1',
    'menu1-2': '菜单1-2',
    'menu1-2-1': '菜单1-2-1',
    'menu1-2-2': '菜单1-2-2',
    'menu1-3': '菜单1-3',
    menu2: '菜单2',
    Table: 'Table',
    dynamicTable: '动态Table',
    dragTable: '拖拽Table',
    inlineEditTable: 'Taele内编辑',
    complexTable: '综合Table',
    treeTable: '树形表格',
    customTreeTable: '自定义树表',
    tab: 'Tab',
    form: '表单',
    createArticle: '创建文章',
    editArticle: '编辑文章',
    articleList: '文章列表',
    errorPages: '错误页面',
    page401: '401',
    page404: '404',
    errorLog: '错误日志',
    excel: 'Excel',
    exportExcel: 'Export Excel',
    selectExcel: 'Export Selected',
    uploadExcel: 'Upload Excel',
    zip: 'Zip',
    pdf: 'PDF',
    exportZip: 'Export Zip',
    theme: '换肤',
    clipboardDemo: 'Clipboard',
    i18n: '国际化',
    externalLink: '外链',
    dashboard: '首页',
    user: '用户',
    catelog: '分组',
    system: '系统',
    profile: '个人设置',
    permission: '权限',
    app: '应用',
    appconfig: '应用配置',
    role: '角色',
    menu: '菜单',
    docs: '对接文档',
    sysconfig: '系统设置',
    optlog: '操作日志',
    agent: '代理',
    card: '卡管理',
    configs: '配置',
    group: '设备管理',
    cardlist: '卡列表',
    grouplist: '设备列表',
    groupSalesChannelList: '销售渠道',
    supplierManage: '通道管理',
    supplier: '通道',
    supplierlist: '通道列表',
    supplierbill: '通道账单',
    cardbatch: '批次',
    cardgroupbatch: '批次',
    cardgroupview: '设备视图',
    package: '套餐',
    packageitem: '套餐内容',
    wechat: '微信',
    cardpackage: '卡套餐',
    cardgrouppackage: '设备套餐',
    deletedcardgrouppackage: '已删除设备套餐',
    cardgrouptotal: '套餐内容',
    wxpub: '公众号',
    partner: '商户号',
    packageManage: '套餐管理',
    product: '产品',
    iotProduct: '产品',
    client_product: '产品',
    packageprice: '套餐价格',
    client: '客户',
    cardkind: '卡品',
    margin: '分润',
    package_margin: '套餐分润',
    regular_margin: '产品分润',
    agentinterest: '活动返利',
    clientdiscount: '折扣',
    clientnotify: '客户通知',
    happening: '活动',
    account: '账户',
    balancelog: '交易记录',
    rakeback: '返佣',
    balancewithdrawals: '提现申请',
    balancetaxrate: '代理税率',
    clientbalancetaxrate: '客户税率',
    withdrawals_account: '提现账户',
    withdrawals_account_serach: '查询提现账户',
    charging: '计费',
    bill: '账单',
    clientbill: '客户账单',
    charge_group: '价格',
    price: '价格内容',
    usage_log: 'SIM卡用量',
    change_log: '变更记录',
    unbindLog: '卡解绑记录',
    cahrge_group: '计费组',
    details: '详情',
    order: '订单管理',
    operation: '运营管理',
    group_logistics: '设备物流',
    rechargeorder: '卡充值订单',
    rechargedeviceorder: '设备充值订单',
    groupPresentOrder: '设备赠品订单',
    upgradedeviceorder: '套餐升级订单',
    refundorder: '卡退款订单',
    refunddeviceorder: '设备退款订单',
    withdrawalsorder: '提现订单',
    clientorder: '客户账户订单',
    agentorder: '代理账户订单',
    help: '问题反馈',
    changecardlog: '换卡管理',
    cardlocation: '地区',
    statistics: '统计分析',
    task: '计划任务',
    handle_task: '批量任务处理',
    handle_task_info: '批量任务处理详情',
    cardusage: '卡用量',
    groupusage: '设备用量',
    finance: '财务管理',
    info: '详细信息',
    cardstatistics: '开卡统计',
    complain: '用户投诉',
    client_mode: '模式',
    client_open_method: '开放接口',
    method: '方法',
    download_task: '批量导出任务',
    polling_task: '批量轮询任务',
    product_config: '套餐改价',
    cardtotal: '套餐内容',
    package_config: '套餐配置',
    supplier_pool: '流量池监控',
    supplier_pool_calculate: '流量池计算',
    cardgroup: '设备',
    member: '成员',
    usage: '周期用量',
    sales_channel: '设置销售渠道',
    codeConfig: '活码配置',
    client_config: '授权配置',
    supplierList: '设备通道',
    operateManage: '运营管理',
    smsNotify: '短信通知记录',
    appNotify: '微信通知记录',
    equity: '用户权益',
    deviceBalanceOrder: '设备预存订单',
    transfer: '提现转账',
    groupBalanceLog: '设备交易记录',
    cardNotify: '通知配置',
    category: '产品分组',
    refundDeviceBalanceOrder: '设备预存退款订单',
    supplierPoolInfo: '流量池详情',
    rechargeClientBalanceOrder: '客户预存订单',
    manualRechargeDeviceLog: '设备手动充值记录',
    manualRechargeLog: '卡手动充值记录'
  },
  server: {
    ip: 'IP地址',
    name: '名称',
    key: '属性',
    value: '值',
    info: '信息',
    create_at: '创建时间',
    update_at: '更新时间'
  },
  location: {
    update_at: '位置更新时间'
  },
  navbar: {
    logOut: '退出登录',
    dashboard: '首页',
    profile: '个人设置',
    theme: '换肤',
    size: '布局大小'
  },
  login: {
    title: '系统登录',
    logIn: '登录',
    username: '账号',
    password: '密码',
    captcha: '验证码',
    any: '随便填',
    thirdparty: '第三方登录',
    thirdpartyTips: '本地不能模拟，请结合自己业务进行模拟！！！'
  },
  documentation: {
    documentation: '文档',
    github: 'Github 地址'
  },
  permission: {
    roles: '你的权限',
    switchRoles: '切换权限',
    tips: '在某些情况下，不适合使用 v-permission。例如：Element-UI 的 Tab 组件或 el-table-column 以及其它动态渲染 dom 的场景。你只能通过手动设置 v-if 来实现。'
  },
  guide: {
    description: '引导页对于一些第一次进入项目的人很有用，你可以简单介绍下项目的功能。本 Demo 是基于',
    button: '打开引导'
  },
  components: {
    documentation: '文档',
    tinymceTips: '富文本是管理后台一个核心的功能，但同时又是一个有很多坑的地方。在选择富文本的过程中我也走了不少的弯路，市面上常见的富文本都基本用过了，最终权衡了一下选择了Tinymce。更详细的富文本比较和介绍见',
    dropzoneTips: '由于我司业务有特殊需求，而且要传七牛 所以没用第三方，选择了自己封装。代码非常的简单，具体代码你可以在这里看到 @/components/Dropzone',
    stickyTips: '当页面滚动到预设的位置会吸附在顶部',
    backToTopTips1: '页面滚动到指定位置会在右下角出现返回顶部按钮',
    backToTopTips2: '可自定义按钮的样式、show/hide、出现的高度、返回的位置 如需文字提示，可在外部使用Element的el-tooltip元素',
    imageUploadTips: '由于我在使用时它只有vue@1版本，而且和mockjs不兼容，所以自己改造了一下，如果大家要使用的话，优先还是使用官方版本。'
  },
  table: {
    app_id: '应用ID',
    app_name: '应用名称',
    app_secret: '应用密钥',
    file_name: '文件名称',
    source_type: '赠送来源',
    inherit: '用户类型',
    operator1: '制造商',
    model: '型号',
    main_type: '主类型',
    field: '类别',
    dynamicTips1: '固定表头, 按照表头顺序排序',
    dynamicTips2: '不固定表头, 按照点击顺序排序',
    dragTips1: '默认顺序',
    dragTips2: '拖拽后顺序',
    title: '标题',
    importance: '重要性',
    type: '类型',
    tax_rate: '税率',
    quota: '最高限额',
    remark: '点评',
    search: '搜索',
    add: '添加',
    batchAdd: '批量添加',
    export: '导出',
    reviewer: '审核人',
    id: '序号',
    groupId: '设备号',
    date: '时间',
    author: '作者',
    readings: '阅读数',
    status: '状态',
    actions: '操作',
    edit: '编辑',
    publish: '发布',
    draft: '草稿',
    delete: '删除',
    cancel: '取 消',
    confirm: '确 定',
    user_id: '用户id',
    username: '用户名',
    email: '邮箱',
    name: '名称',
    catelog: '分组',
    creator: '创建人',
    parent: '上级',
    info: '信息',
    newPassword: '新密码',
    oldPassword: '当前密码',
    passwordConfirm: '确认密码',
    permission: '权限',
    allPermission: '所有权限',
    action: '动作',
    import: '导入',
    calculate: '核算',
    fahuoImport: '发货信息录入',
    gid: '单号',
    amount: '金额',
    merchant: '商户',
    secret: '密钥',
    nopaid: '未支付',
    paid: '已支付',
    notified: '已通知',
    paid_at: '支付时间',
    create_at: '创建时间',
    update_at: '更新时间',
    phone: '电话',
    allRole: '所有角色',
    role: '角色',
    notify_url: '回调地址',
    params: '参数',
    param1: '参数1',
    param2: '参数2',
    param3: '参数3',
    param4: '参数4',
    param5: '参数5',
    client_ip: 'IP',
    url: 'Url',
    subject: '标题',
    body: '说明',
    time: '时间',
    begin: '开始',
    begin_time: '开始时间',
    end_time: '结束时间',
    end: '结束',
    update: '更新',
    day: '日期',
    weight: '权重',
    enable: '启用',
    disable: '停用',
    pay: '测试',
    qrcode: '二维码',
    callback_url: '跳转地址',
    template: '模板',
    config: '设置',
    address: '地址',
    company: '姓名',
    min_amount: '最小提现金额',
    multiple: '提现倍数',
    iccid: 'ICCID',
    imei: 'IMEI',
    imsi: 'IMSI',
    msisdn: 'MSISDN',
    operator: '运营商',
    agent: '代理',
    supplier: '通道',
    view: '视图',
    supplierUpdate: '通道更新',
    withdrawapi: 'API下发',
    in_card_no: '卡号',
    in_card_name: '姓名',
    in_bank_name: '银行',
    paid2: '已转账',
    withdraw: '客户单号',
    gidtype: '类型',
    totalAmount: '余额',
    clearing: '清算',
    create_by: '操作员',
    desc: '说明',
    reverse: '关闭',
    reversed: '已关闭',
    transfer2: '转账',
    packageItems: '套餐内容',
    packageItemsSelected: '已选择',
    price: '基础价格/元',
    new_price: '改价/元',
    totalItem: '总量',
    unit: '单位',
    batches: '批次',
    allBatches: '所有批次',
    details: '详情',
    order: '顺序',
    applyShipments: '申请发货',
    approval: '审批',
    approvalStatus: '审批状态',
    approvalwait: '待审批',
    approvalin: '审批中',
    approvalyes: '审批通过',
    approvalno: '审批不通过',
    problem: '问题',
    reply: '回复',
    result: '解决',
    read: '查看',
    resetPassword: '密码重置',
    state: '状态',
    waybill_status: '物流状态',
    waybill_name: '物流公司',
    waybill_no: '运单号',
    card_distribution: '配卡',
    batch_card_distribution: '批量配卡',
    batch_run: '批量运行',
    batch_stop: '批量停止',
    examine_desc: '审核说明',
    advanced_search: '高级查询',
    mode: '模式',
    bind: '绑定',
    cert_number: '身份证号码',
    active: '激活时间',
    download: '下载',
    retry: '重试',
    recover: '恢复订购信息',
    key: '属性',
    value: '值',
    reload: '重置',
    client_open_method: '开放接口',
    up_traffic: '运营商总流量（MB）',
    up_traffic2: '运营商使用流量（MB）',
    our_traffic: '我方总流量（MB）',
    sb_traffic: '差值（MB）',
    traffic: '使用量（MB）',
    total_traffic: '总流量（GB）',
    effect_traffic: '生效中（GB）',
    used_traffic: '已使用（GB）',
    not_effect_traffic: '未生效（GB）',
    capacity: '最大成员',
    usgae_ratio: '使用率',
    card_count: '卡片数',
    total: '总量',
    used: '已使用',
    validity: '有效期',
    cycle_end: '本周期截止',
    citycode: '城市代码',
    adcode: '地址代码',
    high_risk: '禁区',
    expired: '有效期',
    open_at: '入网时间',
    supplier_goods_id: '通道产品编号',
    supplier_goods_channel: '通道触点ID',
    supplier_goods_name: '通道产品名称',
    supplier_bill_calculate: '账单核算',
    num_province_code: '归属省份编码',
    num_city_code: '归属地市编码',
    image: '图片',
    url_detail_template: '推广页面地址模板',
    check_bill: '对账',
    bill_add: '添加账单',
    import_card: '设备绑卡',
    adjusted_flow: '用量调整',
    old_order_id: '原订单号',
    logistics_number: '物流单号',
    logistics_company: '物流公司',
    logistics_status: '物流状态',
    receipt_time: '签收时间',
    first_pay_status: '首充状态',
    first_pay_time: '首充时间',
    activate_status: '激活状态',
    import_waybill_no: '批量绑定物流单号',
    import_waybill_template: '绑定物流模板',
    batch_approval: '批量审核',
    batch_approval_template: '批量审核模板',
    clickAudit: '一键审核',
    displaceCard: '卡一键置换',
    new_iccid: '新卡iccid',
    cardPool: '卡池',
    wechat: '公众号',
    mch_id: 'id',
    mch_key: 'key',
    wechat_pay: '商户',
    config_password: '秘钥',
    is_cmd: '是否下发指令',
    tips: '标签',
    mobile: '手机号',
    present: '礼品',
    login_expired_time: '登录失效时间(分钟)',
    pay_type: '支付方式',
    pay_type2: '支付类型',
    through_id: '套餐id',
    cron: '调度规则',
    editPackage: '套餐编辑',
    removeInfo: '删除明细'
  },
  errorLog: {
    tips: '请点击右上角bug小图标',
    description: '现在的管理后台基本都是spa的形式了，它增强了用户体验，但同时也会增加页面出问题的可能性，可能一个小小的疏忽就导致整个页面的死锁。好在 Vue 官网提供了一个方法来捕获处理异常，你可以在其中进行错误处理或者异常上报。',
    documentation: '文档介绍'
  },
  excel: {
    export: '导出',
    selectedExport: '导出已选择项',
    placeholder: '请输入文件名(默认excel-list)'
  },
  zip: {
    export: '导出',
    placeholder: '请输入文件名(默认file)'
  },
  pdf: {
    tips: '这里使用   window.print() 来实现下载pdf的功能'
  },
  theme: {
    change: '换肤',
    documentation: '换肤文档',
    tips: 'Tips: 它区别于 navbar 上的 theme-pick, 是两种不同的换肤方法，各自有不同的应用场景，具体请参考文档。'
  },
  tagsView: {
    refresh: '刷新',
    close: '关闭',
    closeOthers: '关闭其它',
    closeAll: '关闭所有'
  },
  dialog: {
    'Create': '新建',
    'Edit': '编辑',
    'Withdrawals': '提现申请',
    'BatchApproval': '批量审核'
  },
  sysConfig: {
    'merchant_role': '商户角色',
    'merchant_catelog': '商户分组'
  },
  happening: {
    'amount': '返利（元）',
    'total': '总期数',
    'start': '开始期数',
    'continue': '连续使用'
  },
  group: {
    active: '设置主卡',
    update_state: '修改状态',
    app: '应用设置'
  },
  card: {
    callback_url: '回调地址',
    callback_secret: '回调密钥',
    event_type: '监控类型',
    withdrawal_setting: '提现设置',
    package_through_id: '设备套餐序号',
    back: '退回',
    kf_url: '客服二维码链接',
    spec: '设备型号',
    recharge_url: '充值二维码链接',
    reset_margin: '返佣返利',
    present_product: '用户绑定赠送产品',
    refund_method: '退款方式',
    refund_item: '退款项目',
    gift_amount: '赠送次数',
    gift: '赠品',
    change_card_log_id: '序号',
    wechat_pay: '微信支付',
    balance_pay: '余额支付',
    wechat_pay_quota: '微信支付额度',
    balance_pay_quota: '余额支付额度',
    batch_product_add: '批量赠送',
    goods_type: '商品类型',
    begin: '周期开始时间',
    begin_time: '开始时间',
    happening: '活动',
    prepare: '提前续充天数',
    resetlocation: '定位重置',
    group: '设备',
    username: '姓名',
    tIccid: '新卡ICCID',
    addr: '详细地址',
    package_id: '套餐ID',
    package: '套餐',
    delete_package: '删除套餐',
    deleted_package: '已删除套餐',
    recover_package: '恢复套餐',
    packages: '套餐',
    configs: '配置',
    channel: '渠道',
    packagesSelected: '已选择',
    manager_role: '管理员角色',
    agent_role: '代理商角色',
    agent_catelog: '代理商分组',
    client_role: '客户角色',
    package_enabled: '生效中',
    package_effect: '生效时间',
    package_duration: '套餐周期',
    dispatch: '分配',
    unit: '单位',
    is_unlimited: '是否无限量',
    cahrge_group: '价格',
    period: '期数',
    wechat: '公众号',
    packageprice: '套餐价格',
    balance: '余额',
    frozen: '冻结',
    security_ratio: '保证金比例',
    security_ratio_input: '请输入保证金比例',
    withdrawal_setting_min_amount_input: '请输入最小提现金额',
    withdrawal_setting_multiple_input: '请输入提现倍数',
    security_amount: '保证金',
    security_amount_input: '请输入保证金',
    securityset: '退款保证金设置',
    price: '价格',
    package_day: '结算日',
    usage: '用量',
    usages: '用量',
    bind: '绑定',
    unbind: '解绑',
    agent_id: '代理ID',
    agent: '代理',
    agent_name: '代理名称',
    client_name: '客户名称',
    client: '客户',
    superior: '上级',
    highest: '一级',
    kind: '卡品',
    supplier_pid: '通道产品id',
    margin: '分润',
    amount: '数量',
    count: '数量',
    monitor: '监控',
    network: '网络',
    allocation: '划拨',
    reset: '调回',
    transfer: '转移',
    order_transfer: '订单转移',
    level: '等级',
    money: '金额',
    iccid: 'ICCID',
    serial: '卡号',
    serial_number: '序列号',
    newSerial: '新卡号',
    batches_name: '批次名称',
    batches_id: '批次ID',
    number: '号码',
    iccidRange: 'ICCID范围',
    serialRange: '卡号范围',
    msisdnRange: 'MSISDN范围',
    imeiRange: 'IMEI范围',
    certification: '实名',
    reaID: '实名制',
    realNameRemove: '解除实名',
    order_id: '订单ID',
    order_no: '订单号',
    old_order_no: '原订单号',
    up_order_no: '上游订单号',
    withdrawals: '提现',
    virtual: 'XL',
    lasting: '延续使用',
    refund: '退款',
    refresh: '刷新',
    present: '客服赠送',
    supersuperior: '一级代理',
    account: '收款账户',
    effect_time: '生效时间',
    invalid_time: '失效时间',
    enabled: '是否生效',
    traffic_use: '周期流量使用',
    voice_use: '周期语音使用',
    traffic_rest: '周期流量剩余',
    traffic_total_rest: '流量总剩余',
    voice_rest: '周期语音剩余',
    voice_total_rest: '语音总剩余',
    message_rest: '周期短信剩余',
    message_total_rest: '短信总剩余',
    cycle_end: '本周期到期时间',
    cycle_total_end: '预计到期时间',
    add_mode: '叠加模式',
    mobile: '用户手机号',
    system: '手机系统类型',
    traffic: '流量',
    voice: '语音',
    message: '短信',
    connection: '连接',
    recharge: '充值',
    create_at: '提交时间',
    handle_at: '处理时间',
    quota: '限额',
    code: '区号',
    area: '位置',
    codeDate: '区号更新时间',
    status: '服务状态',
    imei: 'IMEI号',
    change: '变更',
    replace: '换卡',
    device_replace: '换设备',
    objectId: '对象ID',
    changeBefore: '变更前',
    changeAfter: '变更后',
    exact: '限制',
    expect_operator: '期望置换运营商',
    displace: '数据转移',
    batch_displace: '批量数据转移',
    batch_update: '批量更新',
    offlineExport: '线下导出',
    displace_desc: '数据转移说明',
    online: '在线',
    operator: '操作员',
    method: '方法',
    product: '产品',
    tag_id: '标识',
    taskname: '任务名称',
    key: '属性',
    value: '值',
    updatePrice: '改价',
    user: '用户',
    discount: '折扣',
    url: '链接',
    cert_name: '姓名',
    cert_no: '身份证号码',
    post_area: '收货地区',
    post_addr: '详细地址',
    phone_num: '订购号码',
    post_name: '收货人姓名',
    post_phone_num: '收货人电话',
    express: '物流公司',
    express_no: '物流单号',
    operate_order_no: '运营商订单号',
    regular_referral_link: '推广链接',
    upgrade: '套餐升级',
    sms_template: '短信模板',
    logistics_code: '物流状态',
    logistics_code_selected: '已选择',
    postpone: '一键顺延',
    factoryReset: '恢复出厂设置',
    payConfig: '配置',
    notice_config: '短信配置',
    active: '主卡',
    pay: '商户名',
    slot_count: '卡槽数',
    sales_channel_name: '出售渠道',
    sales_channel: '出售',
    sales_time: '出售时间',
    recharge_number: '累计充值次数',
    product_desc: '产品说明',
    remark: '备注',
    codeConfig: '活码配置',
    resetCode: '重置秘钥',
    activeRecharge: '自主充值',
    kind_type: '类型',
    template: '模版',
    result: '结果',
    send_data: '发送内容',
    desc: '描述',
    cardgrouptotal: '套餐内容',
    cardtotal: '套餐内容',
    cardgroupusage: '用量调整',
    tax_rate_amount: '税额',
    arrival_amount: '实际到账金额',
    export: '导出',
    type: '设备类型'
  },

  withdrawals: {
    amount: '提现金额',
    invoice: '是否开票',
    bank: '开户行及支行',
    before_amount: '提现前余额',
    tax_amount: '税额',
    after_tax_amount: '税后提现金额',
    after_amount: '提现后余额',
    all: '全部提现',
    account_number: '账号',
    realname: '名称',
    amount_cond: '100以上即可提现',
    account_number_cond: '微信号/支付宝账户/银行卡号',
    apply_time: '申请时间',
    handle_time: '处理时间'
  },
  bill: {
    id: '账单ID',
    amount: '实际用量',
    amount_charge: '金额',
    charge_name: '价格',
    usage_charge: '用量',
    cycle: '周期',
    effect: '生效日期',
    device: '设备数',
    total_amount: '总费用',
    message_amount: '短信费用',
    traffic_amount: '流量费用',
    voice_amount: '通话费用',
    other_charge: '其他费用',
    traffic: '流量使用',
    message: '周期短信流量',
    voice: '周期语音流量',
    connection: '周期激活流量',
    status: '状态',
    publish: '是否发布',
    deductions: '是否扣费',
    date: ' 账单日期',
    type: '账单类型',
    clientId: '客户ID',
    clientName: '客户'
  },
  wechat: {
    appid: 'APPID',
    openid: 'OpenId',
    secret: '密钥',
    mch_id: '商户ID',
    name: '商户名',
    method: '方式',
    status: '状态',
    configs: '配置',
    mch_key: '商户key',
    pay_weight: '商户配置{"商户ID":"权重"}',
    domain: '域名',
    send_status: '发送状态',
    send_result: '发送结果'
  },
  user: {
    user: '用户',
    mobile: '用户手机号',
    idcard: '身份证'
  },
  card_statistics: {
    card_count: '卡数',
    cucc_activate: '联通激活',
    cucc_unactivate: '联通未激活',
    cucc_deactivate: '联通停卡',
    cucc_count: '联通卡数',
    cucc_activate_rate: '联通开卡率',
    ctcc_activate: '电信激活',
    ctcc_unactivate: '电信未激活',
    ctcc_deactivate: '电信停卡',
    ctcc_count: '电信卡数',
    ctcc_activate_rate: '电信开卡率',
    cmcc_activate: '移动激活',
    cmcc_unactivate: '移动未激活',
    cmcc_deactivate: '移动停卡',
    cmcc_count: '移动卡数',
    cmcc_activate_rate: '移动开卡率',
    activate_rate: '开卡率'
  },
  rule: {
    field: '类别必填',
    error: '兑换类型错误',
    username: '用户名必填',
    company: '姓名必填',
    phone: '电话必填',
    mode: '模式必填',
    client: '客户必填',
    package: '套餐必填',
    margin: '分润必填',
    account: '收款账户必填',
    name: '名称必填',
    status: '状态必填',
    desc: '说明必填',
    user: '用户必填',
    product: '产品必填',
    gift: '赠品必填',
    key: 'key必填',
    value: '值必填',
    period: '期数必填',
    price: '价格必填',
    order: '顺序必填',
    kind: '卡品必填',
    type: '类型必填',
    tag_id: '标识必填',
    agent: '代理必填',
    charge: '资费必选',
    imei: 'imei必填',
    logistics_company: '物流公司必填',
    logistics_number: '物流单号必填',
    method: '类型必填',
    mch_id: 'mch_id必填',
    mch_key: 'key必填',
    pay_weight: '权重必填',
    code: '编码必填',
    template: '模版必填',
    is_cmd: '下发指令状态必选'
  },
  notice: {
    type: '类型',
    title: '主题',
    message: '内容',
    is_read: '是否已读',
    create_at: '发布时间'
  },
  client: {
    type: '类型',
    mode: '模式',
    charge: '资费',
    day: '结算日',
    recharge: '加款',
    active_recharge: '预存',
    own_recharge: '自主充值',
    enable: '一键复机'
  },
  chargeItem: {
    charge: '资费',
    desc: '说明',
    amount: '超出数量',
    unit: '超出单位',
    price: '超出价格',
    basic_amount: '常规数量',
    basic_unit: '常规单位',
    basic_price: '常规价格',
    type: '类型'
  },
  operate: {
    amount: '总量',
    unit: '单位'
  },
  rights: {
    amount: '金额（单位 “元”）',
    discount: '折扣（不填或者填“10” 表示不打折）',
    present: '赠送金额（单位 “元”）'
  },
  deviceBalanceOrder: {
    rights: '权益',
    gift_amount: '赠送金额'
  },
  rechargeGroupOrder: {
    gift_amount: '赠送金额'
  },
  invoicing: {
    type: '开票类型',
    bank: '开户银行',
    bankNo: '银行账号',
    title_type: '抬头类型',
    title_name: '抬头名称',
    tax_id: '税号',
    content: '开票内容',
    email: '收票邮箱',
    address: '注册地址',
    phone: '注册电话',
    amount: '开票金额',
    handle_at: '开票时间',
    status: '开票状态',
    status_desc: '状态说明'
  },
  category: {
    category: '产品分组',
    title: '分组名',
    desc: '说明',
    sort: '排序',
    first: '是否首冲',
    desc_height: '说明高度',
    price_prefix: '价格前缀',
    price_suffix: '价格后缀',
    edit_desc_height: '说明高度(rem)'
  },
  groupBalance: {
    refund: '退款',
    refundTitle: '退款',
    refund_amount: '充值退款金额 (元)',
    refund_gift_amount: '赠送退款金额 (元)',
    amount: '总余额',
    gift_amount: '赠送余额',
    amount_frozen: '冻结金额',
    balanceRecharge: '余额充值'
  },
  batch: {
    clean_time: '清除时间',
    clean_user_info: '清除用户信息',
    clean_order: '清除订购信息',
    clean_cert: '清除实名',
    clean_sales: '清除销售渠道',
    export_card: '导出绑定卡明细',
    unbind_batch: '批量解绑',
    reset_batch_password: '批量重置'
  },
  supplierPool: {
    supplier_id: '通道',
    pool_group_id: '流量池群组ID',
    pool_group_name: '流量池群组名',
    use_amount: '使用量',
    total_amount: '总量',
    remain_amount: '剩余量',
    card_specification: '流量卡规格(GB)',
    remark: '备注',
    info: '详情',
    pool_id: '流量池ID'
  },
  client_tax_rate: {
    tax_rate: '税率',
    max_quota: '最大限额',
    form_tax_rate: '税率（%）'
  },
  account: {
    transfer: '发起转账',
    recv_name: '接收方名称',
    recv_no: '接收方编号'
  }
}



// WEBPACK FOOTER //
// ./src/lang/zh.js